/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import PayWithPaypalDetailsComponent from './payWithPaypal.component';

const PayWithPaypalModule = angular.module('tinaba.components.services.payWithPaypal', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.payWithPaypal', {
        url: '/payWithPaypal',
        template: '<pay-with-paypal-details></pay-with-paypal-details>'
    });
})
.component('payWithPaypalDetails', PayWithPaypalDetailsComponent);

export default PayWithPaypalModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/payWithPaypal/payWithPaypal.js
 **/